<template>
    <!-- Start Main Content -->
    <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card">
            <h2 class="card-title">Classes List</h2>
        </div>
        <div class="grid grid-cols-12">
            <!-- INITIALIZE CSS CLASS -->
            <div class="hidden">
                <div class="self-center md:col-span-6 md:place-self-end lg:col-span-full inline-block w-auto ml-2 dark:bg-dark-card-two dark:text-white align-middle"></div>
                <div class="hover:bg-primary-500 hover:text-white dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"></div>
                <div class="text-slate-300 border-slate-300 dark:!bg-gray-400 dark:text-slate-300 bg-slate-200/50 first:rounded-l-lg last:rounded-r-lg"></div>
                <div class=" dark:bg-gray-700 dark:!rounded-none transition-all duration-150 ease-linear [&.selected]:bg-[#F2F4F9] dark:[&.selected]:bg-dark-icon"></div>
                <div class="group-[.bordered]:rounded-none group-[.bordered]:border group-[.bordered]:border-gray-200 dark:group-[.bordered]:border-dark-border"></div>
            </div>
            <!-- INITIALIZE CSS CLASS -->
            <div class="tablejs sr-only size-0"></div>
            <!-- BASIC DATA TABLE -->
            <div class="col-span-full">
                <div class="card p-0">
                    <div class="p-6 space-y-4">
                        <table id="basicDataTable" class="datatable">
                            <thead>
                                <tr>
                                    <!-- <th class="bg-[#B2E8D9]">Create Date</th> -->
                                    <th class="bg-[#B2E8D9]">Class Type</th>
                                    <th class="bg-[#B2E8D9]">Staff Name</th>
                                    <th class="bg-[#B2E8D9]">Start Date</th>
                                    <th class="bg-[#B2E8D9]">End Date</th>
                                    <th class="bg-[#B2E8D9]">Description</th>
                                    <th class="px-3.5 py-4">Action</th>
     
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr v-for="(item ,index)  in totalclasslist" :key="item.id">
                                    <!-- <td>{{item.iddate}}</td> -->
                                    <td>{{item.classtype}}</td>
                                    <td>{{item.staffname}}</td>
                                    <td>{{ getOnlyDate(item.startdate+"") }}</td>
                                    <td>{{ getOnlyDate(item.enddate+"") }}</td>
                                    <td>{{item.description}}</td>
                                  
                                    <td class="px-3.5 py-4">
                                        <div class="flex items-center gap-1">
                                            <!-- <button class="btn-icon btn-primary-icon-light size-7"  @click="editModal(item)"  >
                                                <i class="ri-add-line text-danger text-[13px]"></i>
                                            </button> -->

                                            <button class="btn-icon btn-danger-icon-light size-7" @click="deleteModal(item.id)" v-show="userRole === '1'">
                                                <i class="ri-delete-bin-line text-danger text-[13px]"></i>
                                            </button>
           

                                            <!-- <button class="btn-icon btn-danger-icon-light size-7" @click="addfollowup(item)">
                                                <i class="ri-edit-2-line text-inherit text-[13px]"></i>  -->
                                                <!-- Change the icon here -->
                                            <!-- </button> -->


                                        </div>
                                    </td>

                                </tr> 
                            </tbody>
                        </table>
                    </div>
                    <!-- Prism Code -->
                    <div class="p-6 hidden">
                        <pre>
                            <code class="language-markup">
                                &lt;p>Sorry we can't show the huge data table&lt;/p>
                            </code>
                        </pre>
                    </div>
                    <!-- Prism Code -->
                </div>
            </div>
            <!-- BORDERED SELECTION DELETION DATA TABLE -->
            
        </div>
    </div>
    <!-- End Main Content -->


    <!-- start add follow up model -->

  
    <div id="addfollowup" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="background: #00000052;">
        <div class="p-4 w-full max-w-lg max-h-full">
          <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square max-h-full overflow-y-auto">
            <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
              <i class="ri-close-line text-inherit text-xl leading-none"></i>
            </button>
            <div class="p-4 md:p-5">
              
                <div class="mt-7">
                    <label for="tagname" class="form-label">Lead Name *</label>
                    <input type="text" v-model="lead.name" class="form-input" id="first_input" placeholder="Lead Name" autocomplete="off" required>
                  </div>
          
                  <div class="mt-7">
                    <label for="tagname" class="form-label">Contact *</label>
                    <input type="number" v-model="lead.contact" class="form-input" id="first_input" placeholder="Contact" autocomplete="off" required>
                  </div>
          
                  <div class="mt-7">
                    <label for="tagname" class="form-label">Address *</label>
                    <input type="text" v-model="lead.address" class="form-input" id="first_input" placeholder="Address" autocomplete="off" required>
                  </div>
          
                  <div class="mt-7">
                    <label for="tagname" class="form-label">Gender *</label>
                    <input type="text" v-model="lead.gender" class="form-input" id="first_input" placeholder="Gender" autocomplete="off" required>
                  </div>
          
                  <div class="mt-7">
                    <label for="tagname" class="form-label">Age *</label>
                    <input type="number" v-model="lead.age" class="form-input" id="first_input" placeholder="Age" autocomplete="off" required>
                  </div>
          
                  <div class="mt-7">
                    <label for="tagname" class="form-label">Next Date *</label>
                    <input type="date" v-model="lead.nextdate" class="form-input" id="first_input" autocomplete="off" required>
                  </div>
          
                  <div class="mt-7">
                    <label for="tagname" class="form-label">Remark *</label>
                    <input type="text" v-model="lead.remark" class="form-input" id="first_input" placeholder="Remark" autocomplete="off" required>
                  </div>
      
              
      
              <div class="flex justify-end mt-7">
                <button @click="save_package" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Save</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      











     <!-- end add follow up model -->







    
  <!-- Start Edit Modal -->
<div id="editModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="background: #00000052;">
    <div class="p-4 w-full max-w-lg max-h-full">
      <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square max-h-full overflow-y-auto">
        <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
          <i class="ri-close-line text-inherit text-xl leading-none"></i>
        </button>
        <div class="p-4 md:p-5">
          

           <!-- start show data ---------------------------------------------------------------------------------------->
            <!-- start table here -->
      <div class="p-4 md:p-5">
        <table class="min-w-full table-auto">
          <thead class="bg-gray-50">
            <tr>
              <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Entry Date</th>
              <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Remark</th>
              <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Next Date</th>
            </tr>
          </thead>
          <tbody>
             <tr v-for="item in followup_list" :key="item.id" class="bg-white"> 
              
              <!-- <tr v-for="(item ,index)  in leadlists" :key="item.id"> -->
              <td class="px-4 py-2 text-sm text-gray-900">{{item.iddate}}</td>
              <td class="px-4 py-2 text-sm text-gray-900">{{item.remark}}</td>
              <td class="px-4 py-2 text-sm text-gray-900">{{item.nextdate}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- end table -->

            <!-- end show data --------------------------------------------------------------------------------------------------->



          <div class="mt-7">
            <label for="tagname" class="form-label">Next Date *</label>
            <input type="date" v-model="leads.nextdate" class="form-input" id="first_input" autocomplete="off" required>
          </div>
  
          <div class="mt-7">
            <label for="tagname" class="form-label">Remark *</label>
            <input type="text" v-model="leads.remark" class="form-input" id="first_input" placeholder="Remark" autocomplete="off" required>
          </div>
  
          <div class="flex justify-end mt-7">
            <button @click="save_followup" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End Edit Modal -->
  










    
       <!-- Start Delete Modal -->
    <div id="deleteModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
        <div class="p-4 w-full max-w-md max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
                <div class="p-4 md:p-5 text-center">
                    <img src="assets/images/icons/delete-record.png" alt="delete" class="block h-12 mx-auto">
                    <div class="mt-5 text-center">
                        <h5 class="mb-1">Are you sure?</h5>
                        <p class="text-slate-500 dark:text-zink-200">Are you certain you want to delete this record?</p>
                        <div class="flex justify-center gap-2 mt-6">
                            <button type="reset" @click="closeModal" class="btn b-light btn-danger-light btn-sm">Cancel</button>
                            <button type="submit" @click="delete_category" class="btn b-solid btn-danger-solid btn-sm">Yes, Delete It!</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Delete Modal -->
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
name: 'AddProduct',
components: {
 
} ,
mounted(){
 this.getBasics();
},
data() {
 return {
     isAdd:0,
     isEdit:0,
     isDelete: 0,
     deleteId: 0,
     productsList:[],
     leadlist:[],
     stafflist:[],
     leadlists:[],
     totalduelist:[],
     userRole:localStorage.getItem('userRole'),
     totalclasslist:[],
     datatable:null,
     followup_list:[],
    //  product:{name:'',cat:'0',barcode:'',hsn:'',descr:'',gst:'5',unit:'',mrp:'0',prate:'0',salerate:'0',set_rate:'0',set_qty:'0',},
    //  employees: {empname:'',emprole:'0',isMainAdmin:0},

    staff:{
        firstname:'',
        lastname:'',
        phonenumber:'',
        address:'',
        gender:'',
        city:'',
        dateofjoining:'',
        dateofleaving:'',
    },

    totaldue:{
      iddate:'',
      paid:'',
      total:'',
    },


    leads:{
        nextdate:'',
        remark:'',
        lead_id:0,

    },
    classlist:{
        idddate:'',
        classtype:'',
        staffid:'',
        startdate:'',
        enddate:'',
        description:'',        

    },

    selected_leadid:0,


    lead: { 
                
                name: '', 
                contact:'',
                address:'',
                gender:'',
                age:'',
                nextdate:'',
                remark:'',

            
            },
 }
 }, 
methods:{
  getOnlyDate(date){
    
    try {
    if(date){
      var dateHere=date;
      return dateHere.split(' ')[0];
    }else
    return '';
      
    } catch (error) {
      alert(error);
    return '';
    }
    
  },
 closeModal(){
     
    $("#editModal").addClass('hidden');
            $("#deleteModal").addClass('hidden');
        this.isAdd=0;
        this.isEdit=0;
        this.isDelete=0;
        this.deleteId=0;
        
 },
 addModal(){
     this.cat={name:'',status:'Active'};
     if(!this.isAdd)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
     this.isAdd=!this.isAdd;
 },

 editModal(item){
     if(item){
      var self = this; 
        this.leads.lead_id=item.id;
        axios.post('getleadbyid',{leadeid:item.id}).then(function (response) {
                  self.followup_list=response.data.followup_list;
                  console.log(self.followup_list);
                  self.employees=response.data.userDetails;
                }).then(()=>{ 
                    // self.datatable= $(".datatable").DataTable({
                    //         "paging": true,
                    //         "ordering": true,  
                    //         "autoWidth": false });
              
                    });;

                 


     }
     if(!this.isEdit)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
     this.isEdit=!this.isEdit;
 },


 save_package() {
             var self = this; 
             axios.post('addlead', this.lead)
                 .then(response => {
                     var msg = response.data.msg;
                     var isSuccess = response.data.status;
                    //  self.packageList=response.data.packages;
                    //  self.employees=response.data.userDetails;
                     self.getBasics();
                     self.closeModal();
                    //  self.cat={name:'',status:'Active'};

                     //self.$swal(msg);
                    //  if (isSuccess == 1) {
                    //      self.closeModal();
                    //  }
                 })
                 .catch(error => {
                     console.log('Error on Authentication: ' + error);
                 });
         },

         save_followup() {
             var self = this; 
             axios.post('addfollowup', this.leads)
                 .then(response => {
                     var msg = response.data.msg;
                     var isSuccess = response.data.status;
                    //  self.packageList=response.data.packages;
                    //  self.employees=response.data.userDetails;
                     self.getBasics();
                     self.closeModal();
                    //  self.cat={name:'',status:'Active'};

                     //self.$swal(msg);
                    //  if (isSuccess == 1) {
                    //      self.closeModal();
                    //  }
                 })
                 .catch(error => {
                     console.log('Error on Authentication: ' + error);
                 });
         },




 
 deleteModal(id){
    this.deleteId=id;
     if(!this.isDelete)
         $("#deleteModal").removeClass('hidden');
     else
         $("#deleteModal").addClass('hidden');
     this.isDelete=!this.isDelete;
 },
 async getBasics() {
       var self=this;
         axios.post('showclasslist').then(function (response) {
                  self.totalclasslist=response.data.classlist;
                  self.employees=response.data.userDetails;
                }).then(()=>{ 
                    self.datatable= $(".datatable").DataTable({
                            "paging": true,
                            "ordering": true,  
                            "autoWidth": false });
              
                    });;
  }, 

  // async getBasicsfollowup() {
  //      var self=this;
  //        axios.post('getLeadListfollowup').then(function (response) {
  //                 self.leadlists=response.data.leads;
  //                 self.employees=response.data.userDetails;
  //               });
  // }, 

 






// async getBasics() {
//             var self = this;
//             axios.post('getLeadList').then(function (response) {
//                  self.catList = response.data.cats;
//                  self.employees = response.data.userDetails;
//             });
//         },

            delete_category() {
                var self = this; 
                axios.post('deleteclass', {deleteId:this.deleteId})
                    .then(response => {
                        self.totalclasslist=response.data.classlist;
                        self.employees=response.data.userDetails; 
                         self.closeModal(); 
                         //self.fetchStaffList();
                         location.reload();
                         
                    })
                    .catch(error => {
                        console.log('Error on Authentication: ' + error);
                    });
            },
}
}
</script>
